import { InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface AbstractScanner<
  BarcodeFormat = any[],
  TDevice = MediaDeviceInfo
> {
  hasCameraPermission: BehaviorSubject<boolean | null>;
  valueScanned: Subject<any>;
  errorEmitted: Subject<any>;
  camerasFound: Subject<TDevice[]>;
  selectedCameraDevice$: BehaviorSubject<TDevice | undefined>;
  isRan: boolean;
  supportedFormats: BarcodeFormat;

  runScanner(): Observable<void>;
  stopScanner(): Observable<void>;
  setPermission(hasCameraPermission: Event | boolean): void;
}

export const APP_SCANNER = new InjectionToken<AbstractScanner>('appScanner');
